import React from 'react';
import { Button, Badge } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';

const TYPE_LABELS = {
  oldschool: 'Old School',
  newschool: 'New School',
  middleschool: 'Middle School',
  custom: 'Custom',
};

const FAME_LABELS = {
  unknown: { label: 'غير معروف', color: 'gray' },
  known: { label: 'معروف', color: 'blue' },
  famous: { label: 'مشهور', color: 'yellow' },
};

const ServersTable = ({ data, page, handleUpdate, handleDelete, handleApprove }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>الاسم</th>
        <th>النوع</th>
        <th>المستوى</th>
        <th>الترتيب</th>
        <th>صاحب السيرفر</th>
        <th>الأصوات</th>
        <th>الحالة</th>
        <th>إجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((server, idx) => (
        <tr key={server._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{server.name_ar}</td>
          <td>{TYPE_LABELS[server.type] || server.type}</td>
          <td>{server.level}</td>
          <td>{server.order ?? 0}</td>
          <td>
            <Badge colorScheme={(FAME_LABELS[server.fame] || FAME_LABELS.unknown).color}>
              {(FAME_LABELS[server.fame] || FAME_LABELS.unknown).label}
            </Badge>
          </td>
          <td>{server.votes}</td>
          <td>
            {server.is_active
              ? <Badge colorScheme="green">نشط</Badge>
              : <Badge colorScheme="orange">بانتظار الموافقة</Badge>}
          </td>
          <td>
            {!server.is_active && (
              <Button bg="transparent" color="teal.300" size="xs" title="موافقة" onClick={() => handleApprove(server)}>
                <FiIcons.FiCheckCircle size={20} />
              </Button>
            )}
            <Button bg="transparent" color="green" size="xs" onClick={() => handleUpdate(server)}>
              <FiIcons.FiEdit size={20} />
            </Button>
            <Button bg="transparent" color="red.600" size="xs" onClick={() => handleDelete(server)}>
              <FiIcons.FiDelete size={20} />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ServersTable;
